module.exports = __webpack_public_path__ + "longLogo.cc558b00.png";